import { useEffect, useMemo, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { merchItems } from './data'
import { getSortedItems } from './utils'

export function useMerchShelf() {
  const navigate = useNavigate()
  const { category } = useParams()

  const [searchTerm, setSearchTerm] = useState('')
  const [showFilters, setShowFilters] = useState(false)
  const [sortOption, setSortOption] = useState('name')
  const [darkMode, setDarkMode] = useState(false)
  const [hoveredItemId, setHoveredItemId] = useState<string | null>(null)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    setDarkMode(localStorage.getItem('darkMode') === 'true')
    const handleMouseMove = (e: MouseEvent) =>
      setMousePosition({ x: e.clientX, y: e.clientY })
    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  const filteredItems = useMemo(() => {
    return merchItems.filter((item) => {
      const matchesSearch = item.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
      const matchesCategory = !category || item.category === category
      return matchesSearch && matchesCategory
    })
  }, [searchTerm, category])

  const sortedItems = useMemo(
    () => getSortedItems(filteredItems, sortOption),
    [filteredItems, sortOption],
  )

  const navigateToCategory = (cat: string) => navigate(`/merch/shelf/${cat}`)
  const navigateToEdit = (id: string) => navigate(`/merch/${id}/edit`)

  return {
    category,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    sortOption,
    setSortOption,
    darkMode,
    hoveredItemId,
    setHoveredItemId,
    mousePosition,
    sortedItems,
    navigateToCategory,
    navigateToEdit,
    navigate,
  }
}
